var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiversificacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.529,
    height: 74.663,
    viewBox: "0 0 104.529 74.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5038",
    "data-name": "Path 5038",
    d: "M255.758,1138.966a5.374,5.374,0,0,1-1.388-3.844,5.6,5.6,0,0,1,3.733-5.357v-.243a1.867,1.867,0,1,1,3.733,0H263.7a1.867,1.867,0,0,1,0,3.733h-4.293c-.728,0-1.344.858-1.344,1.867s.616,1.867,1.344,1.867h1.083a5.358,5.358,0,0,1,5.077,5.6,5.6,5.6,0,0,1-3.733,5.376v.224a1.867,1.867,0,1,1-3.733,0h-1.867a1.867,1.867,0,0,1,0-3.733h4.293c.728,0,1.344-.84,1.344-1.866s-.617-1.867-1.344-1.867h-1.083a5.376,5.376,0,0,1-3.688-1.756m-8.968-13.309a18.665,18.665,0,1,0,13.2-5.467,18.665,18.665,0,0,0-13.2,5.467",
    transform: "translate(-241.322 -1120.19)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.804,
    y1: 7.336,
    x2: -1.797,
    y2: 7.336,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59964a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc14b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5039",
    "data-name": "Path 5039",
    d: "M565.691,1269.192v22.4a1.867,1.867,0,0,0,3.733,0v-22.4a1.867,1.867,0,0,0-3.733,0",
    transform: "translate(-565.691 -1267.325)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -42.288,
    y1: 8.909,
    x2: -42.214,
    y2: 8.909,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5040",
    "data-name": "Path 5040",
    d: "M205.088,1321.376a1.865,1.865,0,1,0,1.319-.547,1.865,1.865,0,0,0-1.319.547",
    transform: "translate(-204.542 -1320.829)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -14.676,
    y1: 58.364,
    x2: -14.604,
    y2: 58.364,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5041",
    "data-name": "Path 5041",
    d: "M204.541,1349.448v7.466a1.867,1.867,0,1,0,3.733,0v-7.466a1.867,1.867,0,1,0-3.733,0",
    transform: "translate(-204.541 -1347.581)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -15.292,
    y1: 18.789,
    x2: -15.217,
    y2: 18.789,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5042",
    "data-name": "Path 5042",
    d: "M235.056,1295.324a1.867,1.867,0,0,1,1.867-1.867h31.732a1.867,1.867,0,0,1,0,3.733H236.922a1.867,1.867,0,0,1-1.867-1.867m0-7.466a1.867,1.867,0,0,1,1.867-1.867h31.732a1.867,1.867,0,1,1,0,3.733H236.922a1.867,1.867,0,0,1-1.867-1.867m0-7.467a1.867,1.867,0,0,1,1.867-1.866h31.732a1.866,1.866,0,1,1,0,3.733H236.922a1.867,1.867,0,0,1-1.867-1.866m0-7.466a1.867,1.867,0,0,1,1.867-1.867h31.732a1.867,1.867,0,1,1,0,3.733H236.922a1.867,1.867,0,0,1-1.867-1.867m1.867-5.6a12.445,12.445,0,0,0-4.162,16.8,16.913,16.913,0,0,1-1.422,11.4,5.6,5.6,0,0,0,5.585,5.4h31.732a12.444,12.444,0,0,0,4.162-16.8,16.911,16.911,0,0,1,1.423-11.4,5.6,5.6,0,0,0-5.585-5.4Z",
    transform: "translate(-231.334 -1267.325)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1.5,
    y1: 6.929,
    x2: -1.494,
    y2: 6.929,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5043",
    "data-name": "Path 5043",
    d: "M402.255,1198.9a1.866,1.866,0,0,1,1.867-1.867h31.732a1.867,1.867,0,1,1,0,3.733H404.121a1.867,1.867,0,0,1-1.867-1.867m0-7.466a1.866,1.866,0,0,1,1.867-1.866h31.732a1.867,1.867,0,1,1,0,3.733H404.121a1.867,1.867,0,0,1-1.867-1.867m0-7.467a1.867,1.867,0,0,1,1.867-1.866h31.732a1.866,1.866,0,1,1,0,3.733H404.121a1.867,1.867,0,0,1-1.867-1.867m0-7.466a1.866,1.866,0,0,1,1.867-1.866h31.732a1.867,1.867,0,1,1,0,3.733H404.121a1.867,1.867,0,0,1-1.867-1.867m0-7.466a1.867,1.867,0,0,1,1.867-1.867h31.732a1.867,1.867,0,0,1,0,3.733H404.121a1.867,1.867,0,0,1-1.867-1.867m0-7.467a1.867,1.867,0,0,1,1.867-1.866h31.732a1.867,1.867,0,0,1,0,3.734H404.121a1.867,1.867,0,0,1-1.867-1.867m0-7.466a1.867,1.867,0,0,1,1.867-1.867h31.732a1.867,1.867,0,0,1,0,3.733H404.121a1.866,1.866,0,0,1-1.867-1.867m0-7.466a1.867,1.867,0,0,1,1.867-1.867h31.732a1.867,1.867,0,0,1,0,3.733H404.121a1.867,1.867,0,0,1-1.867-1.867m0-7.466a1.867,1.867,0,0,1,1.867-1.867h31.732a1.867,1.867,0,0,1,0,3.733H404.121a1.867,1.867,0,0,1-1.867-1.867m1.867-5.6a12.444,12.444,0,0,0-4.162,16.8,15.82,15.82,0,0,1-1.426,11.2,5.6,5.6,0,0,1,0,7.467,5.6,5.6,0,0,1,0,7.466,5.6,5.6,0,0,1,0,7.466,5.6,5.6,0,0,1,0,7.467,5.873,5.873,0,0,1,0,7.67,5.6,5.6,0,0,0,5.585,5.4h31.732a12.445,12.445,0,0,0,4.162-16.8,15.824,15.824,0,0,1,1.426-11.2,5.6,5.6,0,0,1,0-7.466,5.6,5.6,0,0,1,0-7.467,5.6,5.6,0,0,1,0-7.466,5.6,5.6,0,0,1,0-7.466,5.874,5.874,0,0,1,0-7.671,5.6,5.6,0,0,0-5.585-5.4Z",
    transform: "translate(-398.533 -1133.565)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.585,
    y1: 3.809,
    x2: -2.579,
    y2: 3.809,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2408",
    "data-name": "Group 2408",
    transform: "translate(-883.202 -972.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142",
    transform: "translate(893.466 972.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_903",
    "data-name": "Rectangle 903",
    width: 37.331,
    height: 37.332,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2144",
    "data-name": "Group 2144",
    transform: "translate(983.997 1013.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2143",
    "data-name": "Group 2143",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_904",
    "data-name": "Rectangle 904",
    width: 3.733,
    height: 26.132,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2146",
    "data-name": "Group 2146",
    transform: "translate(883.202 1028.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2145",
    "data-name": "Group 2145",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_905",
    "data-name": "Rectangle 905",
    width: 3.88,
    height: 3.733,
    transform: "translate(-0.147 0)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2148",
    "data-name": "Group 2148",
    transform: "translate(883.202 1036.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2147",
    "data-name": "Group 2147",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    width: 3.733,
    height: 11.199,
    transform: "translate(0)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    "data-name": "Group 2150",
    transform: "translate(890.679 1013.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    "data-name": "Group 2149",
    transform: "translate(0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_907",
    "data-name": "Rectangle 907",
    width: 43.006,
    height: 33.598,
    transform: "translate(-0.049 0)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2152",
    "data-name": "Group 2152",
    transform: "translate(937.344 976.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2151",
    "data-name": "Group 2151",
    transform: "translate(0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_908",
    "data-name": "Rectangle 908",
    width: 43.007,
    height: 70.93,
    transform: "translate(-0.049 0)",
    fill: "url(#linear-gradient-6)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversificacion);
export default __webpack_public_path__ + "static/media/diversificacion.59ea7f453642b799c4b876b781a0e723.svg";
export { ForwardRef as ReactComponent };